export enum TOAST_TYPES {
    SUCCESS = 'success',
    ERROR   = 'error',
    WARNING = 'warning',
    INFO    = 'info',
    DEFAULT = 'default'
};

export interface IToast
{
    id      : number;
    message : string;
    type    : TOAST_TYPES;
}

type UpdatedCallback = (toasts : IToast[]) => void;

export class ToastManager {
    static callbacks : Set<UpdatedCallback> = new Set<UpdatedCallback>();
    static toasts    : IToast[]             = [];

    static addToast(message : string, type : TOAST_TYPES, duration : number = 5000) : number {
        const id = Date.now() + Math.random();

        ToastManager.toasts.push({
            "id"      : id,
            "message" : message,
            "type"    : type
        });

        if (duration !== -1) {
            setTimeout(() => {
                    ToastManager.removeToast(id);
                }, duration);
        }

        ToastManager.callbacks.forEach(callback => {
            callback(ToastManager.toasts);
        });

        return id;
    }

    static onUpdate(updateHandler : UpdatedCallback)
    {
        ToastManager.callbacks.add(updateHandler);
    }

    static removeToast(id : number) 
    {
        ToastManager.toasts = ToastManager.toasts.filter(toast => toast.id !== id);
        ToastManager.callbacks.forEach(callback => {
            callback(ToastManager.toasts);
        });
    }

    static removeUpdateEvent(updateHandler : UpdatedCallback)
    {
        ToastManager.callbacks.delete(updateHandler);
    }
}

